import { SET_OPERATOR_LOGO } from "appRedux/actions/logo";

const initialState = {
  operatorLogo: null,
};

const logoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPERATOR_LOGO:
      return {
        ...state,
        operatorLogo: action.payload,
      };
    default:
      return state;
  }
};

export default logoReducer;
